import { useCallback, useMemo } from 'react';

import { useEventDetailsCache } from '@/hooks/use-sbk-event-details-cache';
import { useSubscribePublic } from '@/utils/websocket/hooks';
import { MatchUpdateMessage } from '@/utils/websocket/types';

/**
 * Subscribe to 'league:{leagueId}' channel and listens for `match_update` messages
 * @param leagueId - League ID
 * @param enabled - Whether to enable the subscription
 */
export const useSubscribeLeagueMatchUpdate = (leagueId: string, enabled: boolean = true) => {
    const handleMatchUpdate = useEventDetailsCache(state => state.actions.handleMatchUpdate);
    const params = useMemo(() => ({ leagueId }), [leagueId]);
    const messageHandler = useCallback(
        (message: MatchUpdateMessage) => {
            if (message.change_type === 'ScoreboardUpdate') {
                handleMatchUpdate(message);
            }
        },
        [handleMatchUpdate]
    );
    useSubscribePublic<'leagueMatchUpdate'>('league:{leagueId}', params, 'match_update', messageHandler, enabled);
};
